import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface StatusEntityParams {
  status: string;
}
export class StatusEntity extends BaseEntityClass {
  status: string;
  constructor(params: StatusEntityParams) {
    super();
    this.type = "status";
    this.entity_version = 2;
    this.status = params.status;
  }
}
